export default ({React,connect,CollapsePanel,ToolbarActions,StylePicker,slate})->

  { Block, Text } = slate

  class MathToolbar extends React.Component

    constructor:(props)->
      super(props)
      @state = {
        size:null
        value:""
      }

    componentDidMount:->
      @stateFromTag()

    componentDidUpdate:(prev_props,prev_state)->
      @stateFromTag() if prev_props.value.change().value.startBlock != @props.value.change().value.startBlock 

    stateFromTag:->
      tag = @getTag()
      return if !tag
      attrs = tag.data.toObject() 
      @setState({size:attrs.size}) if attrs.size?
      @setState({value:attrs.value}) if attrs.value?
      @setState({align:attrs.align || ""}) 

      
    getTag:->
      change = @props.value.change()
      tags = change.value.blocks.filter (node)-> node.type == "duomath"
      return tags.get(0) if tags.size > 0

    updateEditor:()->
      tag = @getTag()
      return if !tag
      change = @props.value.change()
      attrs = {}
      attrs.size = if @state.size? then @state.size else null
      attrs.value = if @state.value? then @state.value else ""
      attrs.align = if @state.align then @state.align else null
      change.setNodeByKey(tag.key, {data: {...tag.data.toObject(),...attrs}}) 
      @props.setValue(change.value)

    render:->
      <CollapsePanel title="Maths Tools">
        <div>
          <div className="formhoriz">
          
            <label>LaTex</label>
            <textarea className="form-control" rows="5" placeholder="E=mc^2" value={@state.value}  onChange={(e)=>@setState({value:e.target.value},=> @updateEditor())} />
            
            <label>Size</label>
            <select className="form-control" value={@state.size}  onChange={(e)=>@setState({size:e.target.value},=> @updateEditor())} >
              <option value="">Default</option>
              <option value="1.5em">x1.5</option>
              <option value="2em">x2</option>
              <option value="3em">x3</option>
              <option value="4em">x4</option>
            </select>

            <label>Align</label>
            <select className="form-control" value={@state.align}  onChange={(e)=>@setState({align:e.target.value},=> @updateEditor())} >
              <option value="">Left</option>
              <option value="center">Center</option>
              <option value="right">Right</option>
            </select>

          </div>
        </div>
      </CollapsePanel>

  connect(
    (state)->
      settings:state.settings
      toolbar_width:state.toolbar_width
      toolbars_active:state.toolbars_active
  )(MathToolbar)